exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".cloud-provider-logo {\n  display: inline-block;\n  margin-right: 3px;\n}\n.cloud-provider-logo .icon {\n  display: inline-block;\n  vertical-align: sub;\n  -webkit-filter: invert(53%) sepia(100%) hue-rotate(50deg);\n  filter: invert(53%) sepia(100%) hue-rotate(50deg);\n}\n.disabled .cloud-provider-logo .icon {\n  -webkit-filter: opacity(64%);\n  filter: opacity(64%);\n}\n.header-text .cloud-provider-logo {\n  margin-right: 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist/cjs.js!./app/scripts/modules/core/src/cloudProvider/cloudProviderLogo.less
// module id = 2511
// module chunks = 0